// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"6df4b81c","714":"3ac74cca"}[chunkId] + ".chunk.js";
};